import script from "./PublicationLogo.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationLogo.vue?vue&type=script&lang=js"
export * from "./PublicationLogo.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/PublicationLogo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e6199ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e6199ea', __exports__)) {
    api.reload('6e6199ea', __exports__)
  }
  
}


export default __exports__